import { SymbolWinResult } from "slotworks/model/gameplay/records/results/symbol-win-result";

export class ScatterResult extends SymbolWinResult {
    public resultType: string = "ScatterResult";
}
